import { SimaESignatureApi } from '~/app/features/e-signature-sima/services/api';
import { ChangeIbanApi } from '~/app/features/required-change-iban/services/api';
import { BiometryEndpoints } from '~/app/modules/biometry';
import { ProcessingEndpoints } from '~/app/modules/processing';

export default ({ $api }) => {
  $api.register('http', '/web/private/client', request => ({
    turnOffGuarantee() {
      return request('POST', `/guarantee/agree`);
    },
    getLegalDocument(id) {
      return request('GET', `/loan-items/${id}/legal-document`, { responseType: 'arraybuffer' });
    },
    updateIban(payload) {
      return request('PUT', '/bank', payload);
    },
    getPersonalDataConsent(documentId = '') {
      return request('GET', `/personal-data-processing-consent-document/${documentId}/download`, {
        responseType: 'arraybuffer',
      });
    },
    paymentMethod() {
      return request('GET', '/application/payment-method');
    },
  }));

  $api.register('geo', '/web/public/address', request => ({
    async getRegions(params) {
      const { success, data } = await request('GET', '/region', { params });
      if (success) {
        return data.map(({ id, publicTitle }) => ({
          id,
          label: publicTitle,
          value: publicTitle,
        }));
      }
    },
  }));

  ChangeIbanApi($api);
  BiometryEndpoints($api);
  ProcessingEndpoints($api);
  SimaESignatureApi($api);
};
